import { formatDraggedTransformOrigin } from "@skilitics/drag-drop";

import { useEventSubscribe } from "../../events/index.ts";
import { useEditingCss } from "./EditingCssPropertiesContext.ts";
import { propertiesEventTypes, type TransformOriginChangeEventOptions } from "./propertiesEventTypes.ts";

type Props = {
  nodeId: number;
};

/**
 * Subscribes to transform origin drag events from the canvas handle and updates
 * the node's CSS transformOrigin through the EditingCssPropertiesContext. The
 * dragged position arrives as start/end fractions; we format it here, where the
 * authored value is known, so the unit of each axis is preserved.
 */
export const TransformOriginUpdateSubscriber = ({ nodeId }: Props) => {
  const { cssProperties, onCssPropertiesChange } = useEditingCss();

  useEventSubscribe(
    propertiesEventTypes.TRANSFORM_ORIGIN_CHANGE,
    ({ nodeId: eventNodeId, fractions, startFractions }: TransformOriginChangeEventOptions) => {
      if (eventNodeId !== nodeId) return;

      const previousValue =
        cssProperties.transformOrigin !== undefined ? String(cssProperties.transformOrigin) : undefined;

      onCssPropertiesChange({
        transformOrigin: formatDraggedTransformOrigin(fractions, startFractions, previousValue),
      });
    },
  );

  return null;
};
